import src from "IMAGE";
export default { src, width: 162, height: 36, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AKSQLtZQRxx0CAoTPQYHDSsGBw4uBgcOLgkLFUUGCA8xALihLddYThx1CQsWSAsNGlsLDhtbCw0aVQsNGloLDRpXtOgME47kWJAAAAAASUVORK5CYII="};
